import {
  Button,
  Collapse,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useState } from "react";
import { convertDate, convertHours } from "../utils/dateConverter";

export default function FilteredRow({
  id,
  rowData,
  removeHandler,
  isDetailedData,
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <TableRow>
        <TableCell style={{ paddingLeft: "30px" }}>
          {convertHours(rowData.createdAt)}
        </TableCell>
        <TableCell>{convertDate(rowData.createdAt)}</TableCell>
        <TableCell>{rowData.model}</TableCell>
        <TableCell>{rowData.brand}</TableCell>
        <TableCell>{rowData.manufacturer}</TableCell>
        <TableCell>{rowData.calibratorName}</TableCell>
        <TableCell>
          <Button
            onClick={() => {
              setOpen((prevOpen) => !prevOpen);
            }}
          >
            Szczegóły
          </Button>
          <Button
            onClick={() => {
              removeHandler(id);
            }}
          >
            Usuń
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableContainer>
              <Table size="small" aria-label="calibration table">
                <TableHead>
                  <TableRow>
                    <TableCell>Parametr</TableCell>
                    {rowData.calibrations
                      .sort((a, b) => a.freq - b.freq)
                      .map((calibration, index) => (
                        <TableCell key={index} align="center">
                          {calibration.freq} Hz
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isDetailedData && (
                    <>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Głośność aplikacji:
                        </TableCell>
                        {rowData.calibrations
                          .sort((a, b) => a.freq - b.freq)
                          .map((calibration, index) => (
                            <TableCell key={index} align="center">
                              {calibration.appVolume}
                            </TableCell>
                          ))}
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Testowane względem [dB SPL]:
                        </TableCell>
                        {rowData.calibrations
                          .sort((a, b) => a.freq - b.freq)
                          .map((calibration, index) => (
                            <TableCell key={index} align="center">
                              {calibration.intensityTestedAgainst}
                            </TableCell>
                          ))}
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Głośność główna:
                        </TableCell>
                        {rowData.calibrations
                          .sort((a, b) => a.freq - b.freq)
                          .map((calibration, index) => (
                            <TableCell key={index} align="center">
                              {calibration.masterVolume}
                            </TableCell>
                          ))}
                      </TableRow>
                    </>
                  )}
                  <TableRow>
                    <TableCell component="th" scope="row">
                      Maksymalna głośność aplikacji [dB SPL]:
                    </TableCell>
                    {rowData.calibrations.map((calibration, index) => (
                      <TableCell key={index} align="center">
                        {Math.round(calibration.maxIntensity * 10) / 10}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
